import React from 'react';

import { useSimpleLoyaltyList } from 'api/simple';
import { InputLimitWidth } from 'components/Layout/Form';
import { FlexContainer } from 'components/Layout/common';
import Label from 'components/Text/Label';
import { FItemSelect } from 'components/formik';
import { policyOptions } from 'containers/Audience/utils';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

const LoyaltyTier: React.FC = () => {
  const { data: loyalties = [] } = useSimpleLoyaltyList();

  const fieldPath = 'filters.loyalty_tier.criteria';

  const { t } = useMultiLanguageTranslation();

  const options = loyalties.flatMap(program =>
    program.tiers.map(tier => ({
      label: `${program.name} / ${tier.name} `,
      value: tier.id
    }))
  );

  return (
    <>
      <FlexContainer>
        <InputLimitWidth>
          <FItemSelect
            name={`${fieldPath}.policy`}
            placeholder={t(
              `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.LoyaltyFilter.Includes`
            )}
            options={policyOptions}
          />
        </InputLimitWidth>
      </FlexContainer>
      <Label
        bold
        style={{ display: 'inline-block', marginBottom: 8 }}
        htmlFor={`${fieldPath}.loyalty_tier_ids`}
      >
        {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.LoyaltyFilter.UsersWhoAchieved`)}
      </Label>
      <div style={{ flex: '1 1 auto' }}>
        <FItemSelect
          name={`${fieldPath}.loyalty_tier_ids`}
          mode="multiple"
          placeholder={t(
            `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.LoyaltyFilter.SelectProgramAndTier`
          )}
          showArrow
          options={options}
        />
      </div>
    </>
  );
};

export default LoyaltyTier;
